import React from 'react';
import { HANDBUCH_FARBEN } from './stil';

/**
 * Fusszeile einer Handbuchseite.
 *
 * Portiert aus `components/document/DocumentFooter.tsx` der Quell-App.
 *
 * `seite` und `gesamtSeiten` kommen von aussen und werden hier NICHT gezaehlt.
 * Die Zaehlung macht `seitenPlan()` in `handbuchLogic.ts` — pure und getestet.
 * Wuerde jede Seite selbst zaehlen, kaemen Bildschirmvorschau und PDF
 * frueher oder spaeter auf verschiedene Gesamtzahlen, und „Seite 4 von 11"
 * auf dem einen und „von 12" auf dem anderen Blatt ist genau die Art Fehler,
 * die im Streitfall die Vollstaendigkeit des Dokuments in Frage stellt.
 */

interface Props {
    /** Linke Spalte: Dokument- und Projektbezeichnung. */
    dokument: string;
    /** Mittlere Spalte: wer es aufgestellt hat. */
    ersteller?: string;
    seite: number;
    gesamtSeiten: number;
    /** Kapitelbezeichnung hinter der Seitenzahl. */
    kapitel?: string;
    /** Stand, bereits als Text formatiert. */
    stand?: string;
}

export const SeitenFuss: React.FC<Props> = ({
    dokument, ersteller, seite, gesamtSeiten, kapitel, stand,
}) => (
    <div
        className="flex justify-between gap-4"
        style={{
            borderTop: `1px solid ${HANDBUCH_FARBEN.linieStark}`,
            paddingTop: '3px',
            marginTop: '6px',
            fontSize: '7.5px',
            color: HANDBUCH_FARBEN.textLeise,
        }}
    >
        <div className="truncate">{dokument}</div>
        <div className="truncate">{ersteller ? `Aufgestellt: ${ersteller}` : ''}</div>
        <div className="truncate shrink-0">
            Seite {seite} von {gesamtSeiten}
            {kapitel ? ` | ${kapitel}` : ''}
            {stand ? ` | Stand: ${stand}` : ''}
        </div>
    </div>
);
